.SpinnerOverlay
    position: absolute
    top: 0
    left: 0
    bottom: 0
    right: 0
    display: flex
    justify-content: center
    align-items: center
    background-color: rgb($globalSettingsBackgroundPrimary)
    opacity: .5
    z-index: 1
    &.FixedStyle
        background-color: rgb(255,255,255)

.SpinnerIcon
    fill: rgb($globalButtonBackgroundPrimary)
    &.FixedStyle
        fill: rgb(42, 173, 186)